import React from "react";
import { useHistory } from "react-router-dom";

import CECYTEJ from "../logos/CECYTEJ.png";
import "./Header.css";

const Header = ({
  alumno,
  modificarAlumno,
  login,
  cambiarLogin,
  cambiarChecked,
  cambiarPagar,
  cambiarPrecio,
  cambiarClaves,
  activarModuloCajero,
}) => {
  let history = useHistory();

  const onClickLogout = () => {
    modificarAlumno({ codigo: "", nombre: "" });
    cambiarLogin(false);
    cambiarPagar(false);
    cambiarPrecio(0);
    cambiarClaves([]);
    
    // Pro-tip: Reseteo dinámico de los 21 checkboxes para ahorrar líneas de código
    const resetCheckboxes = {};
    for (let i = 1; i <= 21; i++) {
      resetCheckboxes[`c${i}`] = false;
    }
    cambiarChecked(resetCheckboxes);

    history.push("/");
  };

  return (
    <header className="Header">
      <div className="container Header-flex">
        <div className="Header-logo">
          <img src={CECYTEJ} alt="Logo CECYTEJ" />
          <h1>Sistema de Pagos</h1>
        </div>
        
        {login ? (
          /* Si hay un alumno logueado, mostramos esto */
          <div className="Header-alumno">
            <p>Hola, {alumno.nombre}</p>
            <a 
              className="Header-logout" 
              onClick={onClickLogout}
              role="button"
              tabIndex="0"
            >
              Salir
            </a>
          </div>
        ) : (
          /* Si NO hay nadie logueado, mostramos el botón de cajero */
          <div className="Header-admin-access">
            <button 
              className="btn-header-admin"
              onClick={() => {
                activarModuloCajero(true); // Cambia el formulario
                history.push("/");         // Lo manda a la pantalla de Login
              }} 
              
            >
              🔒 Acceso Administrativo
            </button>
          </div>
        )}
      </div>
      <hr style={{ margin: 0, border: 'none', borderBottom: '1px solid #e2e8f0' }} />
    </header>
  );
};

export default Header;